//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $Cookies from 'js-cookie'
export default {
      props: {
          ifrUrl: {
              type: String,
              default: ''
          },
          ifrTitle: {
              type: String,
              default: ''
          }
      },
    data(){
        return{
            
        }
    },
    computed: {
      logedLink() {
          let lang = $Cookies.get('lang')
          if(this.$route.query.platformCode){
            // 电子
            if(this.$route.query.gameType === '1'){
                return window.location.origin + `/api/game/forward?UUID=${this.$store.state.UUID}&linkType=1&platformCode=${this.$route.query.platformCode}&platformKey=${this.$route.query.fullName}&gameType=${this.$route.query.gameType}&gameCode=${this.$route.query.gameId}&lang=${lang || en_US}`
            }else if(this.$route.query.gameType !== '1'){
            // 非电子
                return window.location.origin + `/api/game/forward?UUID=${this.$store.state.UUID}&linkType=1&platformCode=${this.$route.query.platformCode}&platformKey=${this.$route.query.platformKey}&gameType=${this.$route.query.gameType}&lang=${lang || en_US}`
            }
          }else{
            return '#'
          }
      }
    },
    methods:{
      goback(){
        this.$emit('setIfrUrl', '')
      }
    }
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/game/iframewrap.vue